import React from "react";

export default function MarqueeBand({ words = [], color = "#ccff00" }) {
  const list = [...words, ...words, ...words]; // duplicate for seamless loop
  return (
    <div className="overflow-hidden border-y border-white/5 bg-[#0a0a0c] py-6" data-testid="marquee-band">
      <div className="marquee-track flex items-center gap-12 whitespace-nowrap">
        {list.map((w, i) => (
          <span key={i} className="display-font text-3xl sm:text-5xl font-black uppercase tracking-tight inline-flex items-center gap-12">
            <span style={{ color: i % 2 === 0 ? color : "#f0f0f5" }}>{w}</span>
            <span className="text-[#2a2a35]">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
